import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

function MeasurementBasisListTwo({
	annualizedBasisHeader,
	annualizedBasisValue,
	asofDateHeader,
	asofDateValue,
	basisValueHeader,
	basisValueValue,
	className,
	showAnnualizedBasis,
	showHelixBasisAmount
}) {
	return (
		<StyledMeasurementBasisListTwo className={className}>
			{showHelixBasisAmount && (
				<section className="basisvalue-fromhelix">
					<span className="basisvalue-header">{basisValueHeader}</span>
					<span className={showAnnualizedBasis ? 'basisvalue-value' : 'annualizedbasis-value'}>{basisValueValue}</span>
				</section>
			)}
			<section className="asof-date">
				<span className="asofdate-header">{asofDateHeader}</span>
				<span className="asofdate-value">{asofDateValue}</span>
			</section>
			{showHelixBasisAmount && showAnnualizedBasis && (
				<section className="annualized-basis">
					<span className="annualizedbasis-header">{annualizedBasisHeader}</span>
					<span className="annualizedbasis-value">{annualizedBasisValue}</span>
				</section>
			)}
		</StyledMeasurementBasisListTwo>
	);
}

MeasurementBasisListTwo.propTypes = {
	annualizedBasisHeader: PropTypes.string,
	annualizedBasisValue: PropTypes.string,
	asofDateHeader: PropTypes.string,
	asofDateValue: PropTypes.string,
	basisValueHeader: PropTypes.string,
	basisValueValue: PropTypes.string,
	className: PropTypes.string,
	showAnnualizedBasis: PropTypes.bool
};

MeasurementBasisListTwo.defaultProps = {
	className: 'measurementbasis-list2'
};

export default MeasurementBasisListTwo;

const StyledMeasurementBasisListTwo = styled.section`
	display: inline-block;
	width: 60%;
	.basisvalue-fromhelix {
		display: inline-block;
		padding-right: var(--px-32);
		.basisvalue-header {
			display: block;
			font-size: var(--px-12);
			font-weight: 300;
			color: var(--neutrals-700);
		}
		.basisvalue-value {
			display: block;
			font-size: var(--px-14);
			font-weight: bold;
		}

		.annualizedbasis-value {
			display: block;
			font-size: var(--px-14);
			font-weight: bold;
			color: var(--green-500);
		}
	}
	.asof-date {
		display: inline-block;
		padding-right: var(--px-32);
		.asofdate-header {
			display: block;
			font-size: var(--px-12);
			font-weight: 300;
			color: var(--neutrals-700);
		}
		.asofdate-value {
			display: block;
			font-size: var(--px-14);
			font-weight: bold;
		}
	}
	.annualized-basis {
		display: inline-block;
		padding-right: var(--px-32);
		.annualizedbasis-header {
			display: block;
			font-size: var(--px-12);
			font-weight: 300;
			color: var(--neutrals-700);
		}
		.annualizedbasis-value {
			display: block;
			font-size: var(--px-14);
			font-weight: bold;
			color: var(--green-500);
		}
	}
`;
